<template>
  <div class="layout">
    <router-view />
  </div>
</template>

<script>
// import { getWechatSign } from '../../api'
import { isWeixin} from '../../utils'
import wx from 'weixin-js-sdk'
export default {
  name: 'Layout',
  methods: {
    handleRouteChange(){
      const url = window.location.href.split("#")[0];
      console.log("===========================================",url);
      // getWechatSign({url}).then(res => {
      //   console.log("getWechatSign res===========================================",res);
      //   if(res.code === 200){
      //     const data = res.data;
      //     console.log('getWechatSign data=',data)
      //     wx.config({
      //       debug: false,
      //       appId: data.appId + '',
      //       timestamp: data.timestamp + '',
      //       nonceStr: data.nonceStr + '',
      //       signature: data.signature + '',
      //       jsApiList: ['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems','hideOptionMenu','showOptionMenu','showMenuItems','scanQRCode'],
      //       openTagList: ['wx-open-launch-app','wx-open-launch-weapp']
      //     });
      //     wx.error(err => {
      //       console.log('getWechatSign err=',err)
      //     });
      //     // wx.ready(() => {
      //     //   wx.hideMenuItems({
      //     //     menuList: ["menuItem:share:qq","menuItem:share:weiboApp","menuItem:share:facebook","menuItem:share:QZone"]
      //     //   })
      //     // });
      //   }
      // })
    }
  },

  watch:{
    '$route':{
      immediate: true,
      handler: function(route) {
        document.title = route.meta.title
        if (
          route.name === "Download" ||
          route.name === "Product" ||
          route.name === "Practice" ||
          route.name === "Reunion" ||
          route.name === "Ticket"||
          route.name === "Home" ||
          route.name === "Participate" ||
          route.name === "Invoice" ||
          route.name === "Receipt" ||
          route.name === 'Themezone'
        ) {
           isWeixin() && this.handleRouteChange()
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.layout{
  height: 100%;
}
</style>
